import React from 'react';
import { Row, Col, Alert } from 'reactstrap';
import { useQuery } from '@apollo/client';
import { ADMIN_OPS_STATUS } from '@api';

import Spinner from '../../Spinner';
import SystemHeader from './SystemHeader.js';
import RoaringIndexPanel from './RoaringIndexPanel.js';
import DeltaSyncPanel from './DeltaSyncPanel.js';
import DelayedJobPanel from './DelayedJobPanel.js';
import CacheSystemPanel from './CacheSystemPanel.js';

export default function AdminOps() {
  const { data, loading, error, refetch } = useQuery(ADMIN_OPS_STATUS, {
    pollInterval: 5000,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: false,
  });

  if (loading && !data) return <div style={{ padding: 24 }}><Spinner /></div>;
  if (error) {
    return (
      <div style={{ padding: 24 }}>
        <Alert color='danger'>
          <strong>Failed to load admin ops status:</strong> {error.message}
        </Alert>
      </div>
    );
  }

  const s = data?.adminOpsStatus;
  if (!s) return null;

  return (
    <div style={{ padding: '80px 24px 40px 24px', background: '#f7f8fa', minHeight: '100vh', fontSize: 15 }}>
      <SystemHeader system={s.system} />
      <Row>
        <Col lg='6' className='mb-3'>
          <RoaringIndexPanel entries={s.roaringIndex} onDone={refetch} />
        </Col>
        <Col lg='6' className='mb-3'>
          <DeltaSyncPanel status={s.deltaSync} onDone={refetch} />
        </Col>
      </Row>
      <Row>
        <Col lg='6' className='mb-3'>
          <DelayedJobPanel summary={s.delayedJob} onDone={refetch} />
        </Col>
        <Col lg='6' className='mb-3'>
          <CacheSystemPanel cache={s.cache} onDone={refetch} />
        </Col>
      </Row>
    </div>
  );
}
